<template>
  <PageContainer pc-only>
    <div class="page-title">{{ $t('message') }}</div>
    <div>
      <ConversationListItem
        v-for="id in conversations"
        :key="id"
        :conversation-id="id"
        :acc-type="accType"
      />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from "@/components/shop/PageContainer.vue";
import ConversationListItem from "@/components/shared/Conversations/ConversationListItem.vue";

export default {
  props: {
    accType: {
      type: String,
      default: ""
    }
  },
  components: {
    PageContainer,
    ConversationListItem
  },

  computed: {
    conversations() {
      return this.$store.state.conversations.listArr;
    }
  },

  async mounted() {
    await this.$store.dispatch("conversations/resetLastId");
    this.$store.dispatch("conversations/getConversations");
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  color: #555;
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 20px;
}
</style>
